import React, {Fragment, useContext} from 'react';
import {observer} from 'mobx-react-lite/dist/index';

import {StoreContext} from '../../helpers/StoreContext';
import {mapHotlinePhone} from '../../helpers/helpers'

import "./Header.scss";

export default observer( () => {

  const rootStore = useContext(StoreContext);
  const styleStore = rootStore.styleStore;
  const hotelStore = rootStore.hotelStore;

  const css = styleStore.Css;
  const html = styleStore.headerHtml;
  const js = styleStore.layoutPartsJS;

  const phoneNumber = mapHotlinePhone[hotelStore.department] ? mapHotlinePhone[hotelStore.department] : "0341 65050 51060";;

  // please don't do this here but more like here:
  // https://git.invia.io/book/booking-app/blob/develop/src/components/utilities/appDynamics.js
  // called here:
  // https://git.invia.io/book/booking-app/blob/develop/src/App.js
  if (js) {
    const script = document.createElement("script");
    script.src = js;
    document.body.appendChild(script);
  }

  if (css) {
    const link = document.createElement("link");
    link.rel ="stylesheet";
    link.type="text/css";
    link.href=css;
    document.body.appendChild(link);
  }

  if ((html)) {

    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(html, 'text/html');
    const desktopPhoneLink = parsedHtml.querySelector('#header > div.hotline-wrapper.bookmark-pos > a');
    const smScreenPhoneLink = parsedHtml.querySelector('#navigation-head-sub > ul > li.item-phone > a');
    const xsScreenPhoneLink = parsedHtml.querySelector('#header > div.toggle-sidebars > div.toggle-sidebar-wrapper > a');
    const hotlinePhoneDiv = parsedHtml.querySelector('#header > div.hotline-wrapper.bookmark-pos');
    
    if (hotelStore.department === undefined && hotlinePhoneDiv) {
      hotlinePhoneDiv.style.visibility = 'hidden';
    };
    
    if (hotelStore.department !== undefined && desktopPhoneLink) {
      desktopPhoneLink.setAttribute('href', `tel:${phoneNumber}`);
      desktopPhoneLink.innerHTML = phoneNumber;
    };

    if (hotelStore.department !== undefined && smScreenPhoneLink) {
      smScreenPhoneLink.setAttribute('href', `tel:${phoneNumber.replaceAll(/\s/g, '')}`);
      smScreenPhoneLink.innerHTML = phoneNumber.replaceAll(/\s/g, '');
    };

    if (hotelStore.department !== undefined && xsScreenPhoneLink) {
      xsScreenPhoneLink.setAttribute('href', `tel:${phoneNumber.replaceAll(/\s/g, '')}`);
    };

    const modifiedHtml= new XMLSerializer().serializeToString(parsedHtml);
    return (
      <Fragment>
        <div className='aidu-header' dangerouslySetInnerHTML={{__html: modifiedHtml}}/>
      </Fragment>
    );
  }

  return '';
});
